import { useEffect } from 'react'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

/** Dispara un evento del Meta Pixel si ya está inicializado. */
export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}

/** Inicializa el Meta Pixel y registra el PageView. */
export function useMetaPixel(pixelId: string): void {
  useEffect(() => {
    if (typeof window === 'undefined' || !pixelId) return

    if (!window.fbq) {
      const fbq: Fbq = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args)
          return
        }
        fbq.queue?.push(args)
      } as Fbq

      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []

      window.fbq = fbq
      window._fbq = fbq
    }

    if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      const script = document.createElement('script')
      script.async = true
      script.src = SCRIPT_SRC
      document.head.appendChild(script)
    }

    window.fbq('init', pixelId)
    window.fbq('track', 'PageView')
  }, [pixelId])
}
